var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkpoints" },
    _vm._l(_vm.checkpoints, function(checkpoint) {
      return _c("composable-checkpoint", {
        attrs: { "checkpoint-name": checkpoint.name },
        nativeOn: {
          dragstart: function($event) {
            return _vm.dragStart($event, checkpoint)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }